export default "__VITE_ASSET__a0bceed7__"